/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
import type { FragmentReference } from "relay-runtime";
declare export opaque type sprintVelocityComponent_viewer$ref: FragmentReference;
declare export opaque type sprintVelocityComponent_viewer$fragmentType: sprintVelocityComponent_viewer$ref;
export type sprintVelocityComponent_viewer = {|
  +insightComponentsData: ?{|
    +sprintVelocity: ?{|
      +useHours: ?boolean,
      +sprints: ?$ReadOnlyArray<?{|
        +title: ?string,
        +sprintId: string,
        +projectGroupSprintId: string,
        +value: ?number,
      |}>,
    |}
  |},
  +$refType: sprintVelocityComponent_viewer$ref,
|};
export type sprintVelocityComponent_viewer$data = sprintVelocityComponent_viewer;
export type sprintVelocityComponent_viewer$key = {
  +$data?: sprintVelocityComponent_viewer$data,
  +$fragmentRefs: sprintVelocityComponent_viewer$ref,
  ...
};
*/


const node/*: ReaderFragment*/ = {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "shareKey",
      "type": "String"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "projectId",
      "type": "ID"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "isProjectGroupType",
      "type": "Boolean"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "sprintVelocityComponent_viewer",
  "selections": [
    {
      "alias": null,
      "args": [
        {
          "kind": "Variable",
          "name": "shareKey",
          "variableName": "shareKey"
        }
      ],
      "concreteType": "InsightComponentsDataType",
      "kind": "LinkedField",
      "name": "insightComponentsData",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": [
            {
              "kind": "Variable",
              "name": "isProjectGroupType",
              "variableName": "isProjectGroupType"
            },
            {
              "kind": "Variable",
              "name": "projectId",
              "variableName": "projectId"
            }
          ],
          "concreteType": "SprintVelocity",
          "kind": "LinkedField",
          "name": "sprintVelocity",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "useHours",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "SprintVelocityElement",
              "kind": "LinkedField",
              "name": "sprints",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "title",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "sprintId",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "projectGroupSprintId",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "value",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Viewer"
};
// prettier-ignore
(node/*: any*/).hash = '15b5ab5e985bb72e9d918dd959e96a62';

module.exports = node;
